import { render, staticRenderFns } from "./UiImageUpload.vue?vue&type=template&id=0b0cfb47&scoped=true"
import script from "./UiImageUpload.vue?vue&type=script&lang=js"
export * from "./UiImageUpload.vue?vue&type=script&lang=js"
import style0 from "./UiImageUpload.vue?vue&type=style&index=0&id=0b0cfb47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0cfb47",
  null
  
)

export default component.exports